<div>
    <m-message state="information">
       <p>
           {{ $i18n.translate('m-session-expired:message') }}
       </p>
    </m-message>
    <p>
        {{ $i18n.translate('m-session-expired:directions-1') }}
    </p>
    <p>
        {{ $i18n.translate('m-session-expired:directions-2') }}
    </p>
    <p>
        <m-link mode="link"
            :url="url"
            :target="target"
            @click="onClick">
            {{ backToLabel }}
        </m-link>
    </p>
</div>
